import type { ChannelMask } from '../../Channels/hooks/useChannelsForSettings'

export const isStartPage = (args: { channel: ChannelMask }): boolean => {
  const { channel } = args
  return channel?.service === 'startPage'
}
